import { IClosureCode } from "us.collection.admin/interfaces";

/**
 * get selected row details
 * @param codeList - Closure code list
 * @param codeId - selected closure code id
 * @returns
 */
export const getSelectedContent = (
  codeList: Array<IClosureCode>,
  codeId: number
): IClosureCode => {
  try {
    if (Array.isArray(codeList)) {
      return codeList?.find((codeDetails: any) => {
        return codeDetails.id == codeId;
      }) as IClosureCode;
    }
    return {} as IClosureCode;
  } catch (error) {
    return {} as IClosureCode;
  }
};
